import { URL_BASE } from "../../../../Globals.ts";

export const handleTriggerVectorSearch = async (
    data: any,
    environmentObjRef: any,
    userObjRef: any
) => {
    const query = data[0];
    const projectPath = data[1];
    const searchId = data[2];

    try {
        const user = userObjRef.current?.user;
        const idToken = user ? await user.getIdToken() : null;

        const response = await fetch(`${URL_BASE}/api/vectorSearch`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(idToken && { "Authorization": `Bearer ${idToken}` })
            },
            body: JSON.stringify({
                query,
                projectPath,
                projectName: environmentObjRef.current?.projectName
            })
        });

        let results = { results: [] };
        if (response.ok) {
            results = await response.json();
        } else {
            console.error(`Vector search failed with status ${response.status}`);
        }

        // Send results back to the IDE
        sendVectorSearchResults(results, searchId, environmentObjRef);
    } catch (error) {
        console.error("Error performing vector search:", error);
        // Send empty results on error
        sendVectorSearchResults({ results: [] }, searchId, environmentObjRef);
    }
};

const sendVectorSearchResults = (
    results: any,
    searchId: string,
    environmentObjRef: any
) => {
    const data = [{
        results: JSON.stringify(results),
        searchId
    }];

    if (environmentObjRef.current?.environment?.includes("jetbrains")) {
        window.jetbrainsPostMessage(JSON.stringify({
            functionName: "vectorSearchResults",
            data
        }));
    } else if (environmentObjRef.current?.environment === "vscode") {
        environmentObjRef.current.vscode?.postMessage({
            functionName: "vectorSearchResults",
            data
        });
    }
};
